export default "__VITE_ASSET__DfBCwNPD__"